import React, { useEffect, useMemo, useState } from 'react';
import { Space, Badge, Input, List, Row, Col, Button, Spin, notification, Grid, theme, Typography, Empty, Card, Modal, Checkbox, Divider, Collapse } from 'antd';
import { ClassItemView } from './ClassItemView';
import { _T } from "../../../../../base-react/src/Localization";
import { DndContext } from "@dnd-kit/core";
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { useNavigate } from 'react-router-dom';
import { CaretUpOutlined, DownOutlined, EditOutlined, MenuOutlined, RightOutlined } from '@ant-design/icons';
import { ClassItemEdit } from './ClassItemEdit';
const { useToken } = theme;
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
var ClassItem = models.classes.ClassItem;
var DivisionSource = models.federations.DivisionSource;
var FederationClassSource = models.federations.FederationClassSource;
var DisciplineSource = models.federations.DisciplineSource;
import { useCompetition } from '../../../../../base-react/hooks/Competition';
const { Search } = Input;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;
export const ClassList = (props) => {
    const { event_id, competition_id, disabled } = props;
    const [classes, loading] = Stream(ClassesSource(competition_id));
    const [sortedClasses, setSortedClasses] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const navigate = useNavigate();
    const hasClasses = ((classes === null || classes === void 0 ? void 0 : classes.length) || 0) > 0;
    useEffect(() => {
        setSortedClasses(classes ? classes : []);
    }, [classes]);
    const onChange = (event) => {
        const value = event.target.value;
        if (!value) {
            setSortedClasses(classes ? classes : []);
            return;
        }
        onSearch(value);
    };
    const onSearch = (value) => {
        if (!value) {
            setSortedClasses(classes ? classes : []);
            return;
        }
        var str = value.toLowerCase();
        var filteredArr = classes === null || classes === void 0 ? void 0 : classes.filter((item) => {
            const name = ClassItem.getClassLabel(item);
            return name.toLowerCase().includes(str);
        });
        setSortedClasses(filteredArr ? filteredArr : []);
    };
    function handleDragEnd({ active, over }) {
        if (!over) {
            return;
        }
        const classIds = classes ? classes.map((e) => e.class_id) : [];
        const newList = arrayMove(classes, classIds.indexOf(active.id), classIds.indexOf(over.id));
        setSortedClasses(newList);
        Api.call(`${ClassesSource(competition_id).url}`, "set-order", newList.map(e => e.class_id))
            .catch(err => {
            //item.dragLoading = false;
            setSortedClasses(classes ? classes : []);
            notification.error({
                message: _T(err.name)
            });
        });
    }
    if (loading) {
        return React.createElement(Spin, null);
    }
    if (!hasClasses) {
        return (React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } },
            React.createElement(Row, { gutter: [16, 16] },
                React.createElement(Col, { xs: 24, md: 12 },
                    React.createElement(Card, { style: { height: '100%' } },
                        React.createElement(Space, { orientation: "vertical", size: "middle", style: { width: '100%' } },
                            React.createElement(Title, { level: 4, style: { margin: 0 } }, _T('class.empty.create.title')),
                            React.createElement(Text, { type: "secondary" }, _T('class.empty.create.description')),
                            React.createElement(Button, { type: "primary", size: "large", disabled: disabled, onClick: () => setShowCreateModal(true) }, _T('class.empty.create.action'))))),
                React.createElement(Col, { xs: 24, md: 12 },
                    React.createElement(Card, { style: { height: '100%' } },
                        React.createElement(Space, { orientation: "vertical", size: "middle", style: { width: '100%' } },
                            React.createElement(Title, { level: 4, style: { margin: 0 } }, _T('class.empty.import.title')),
                            React.createElement(Text, { type: "secondary" }, _T('class.empty.import.description')),
                            React.createElement(Button, { size: "large", disabled: disabled, onClick: () => navigate(`/event/${event_id}/comp/${competition_id}/registration#data`) }, _T('class.empty.import.action')))))),
            React.createElement(CreateClassesFromFederationModal, { competition_id: competition_id, visible: showCreateModal, setVisible: setShowCreateModal, disabled: disabled })));
    }
    return (React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } },
        React.createElement(Search, { placeholder: _T('common.filter'), onChange: onChange, onSearch: onSearch, allowClear: true, enterButton: true, size: "large" }),
        React.createElement(DndContext, { onDragEnd: handleDragEnd },
            React.createElement(SortableContext, { id: competition_id, items: sortedClasses ? sortedClasses.map(a => a.class_id) : [], strategy: verticalListSortingStrategy },
                React.createElement(List, { size: 'small', itemLayout: 'vertical', dataSource: sortedClasses, bordered: true, renderItem: (classItem) => (React.createElement(ClassListItem, { event_id: event_id, competition_id: classItem.competition_id, classItem: classItem, disabled: disabled })) })))));
};
const CreateClassesFromFederationModal = (props) => {
    const { competition_id, visible, setVisible, disabled } = props;
    const [inputCompetition] = useCompetition(competition_id);
    const [divisions] = Stream((inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.federation_id) ? DivisionSource(inputCompetition.federation_id) : undefined);
    const [federationClasses, loadingFederationClasses] = Stream((inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.federation_id) ? FederationClassSource(inputCompetition.federation_id) : undefined);
    const [selectedDivisionIds, setSelectedDivisionIds] = useState([]);
    const [selectedClassIds, setSelectedClassIds] = useState([]);
    const [disciplineNames, setDisciplineNames] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const filteredFederationClasses = useMemo(() => {
        return (federationClasses || [])
            .filter((item) => selectedDivisionIds.includes(item.division_id));
    }, [federationClasses, selectedDivisionIds]);
    const groupedClasses = useMemo(() => {
        return selectedDivisionIds.map((divisionId) => {
            const division = (divisions || []).find((item) => item.division_id === divisionId);
            const divisionClasses = filteredFederationClasses.filter((item) => item.division_id === divisionId);
            const disciplinesMap = divisionClasses.reduce((acc, item) => {
                const disciplineId = String(item.discipline_id || 'unknown');
                if (!acc.has(disciplineId)) {
                    acc.set(disciplineId, {
                        disciplineId,
                        disciplineName: disciplineNames[disciplineId] || disciplineId,
                        classes: []
                    });
                }
                acc.get(disciplineId).classes.push(item);
                return acc;
            }, new Map());
            const disciplines = Array.from(disciplinesMap.values());
            return {
                divisionId,
                divisionName: (division === null || division === void 0 ? void 0 : division.division_name) || divisionId,
                classes: divisionClasses,
                disciplines
            };
        }).filter(group => group.classes.length > 0);
    }, [divisions, filteredFederationClasses, selectedDivisionIds, disciplineNames]);
    useEffect(() => {
        if (!visible) {
            setSelectedDivisionIds([]);
            setSelectedClassIds([]);
            return;
        }
        if (divisions && divisions.length > 0 && selectedDivisionIds.length === 0) {
            setSelectedDivisionIds(divisions.map((item) => item.division_id));
        }
    }, [visible, divisions, selectedDivisionIds.length]);
    useEffect(() => {
        if (!visible || !federationClasses || selectedDivisionIds.length === 0) {
            return;
        }
        const visibleClassIds = new Set(filteredFederationClasses
            .map((item) => item.federation_class_id)
            .filter(Boolean)
            .map((value) => String(value)));
        setSelectedClassIds(current => current.filter(id => visibleClassIds.has(String(id))));
    }, [visible, federationClasses, filteredFederationClasses, selectedDivisionIds.length, selectedClassIds.length]);
    useEffect(() => {
        if (!visible) {
            setDisciplineNames({});
            return;
        }
        if (!(inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.federation_id) || !divisions || divisions.length === 0) {
            return;
        }
        let cancelled = false;
        (async () => {
            const allDisciplines = await Promise.all(divisions.map(async (item) => {
                try {
                    const result = await Api.read(DisciplineSource(inputCompetition.federation_id, item.division_id).url);
                    return (result || []);
                }
                catch {
                    return [];
                }
            }));
            if (cancelled) {
                return;
            }
            const nextLookup = allDisciplines.flat().reduce((acc, item) => {
                if (item === null || item === void 0 ? void 0 : item.discipline_id) {
                    acc[String(item.discipline_id)] = item.discipline_name || String(item.discipline_id);
                }
                return acc;
            }, {});
            setDisciplineNames(nextLookup);
        })();
        return () => {
            cancelled = true;
        };
    }, [visible, inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.federation_id, divisions]);
    const onClose = () => {
        if (isSaving) {
            return;
        }
        setVisible(false);
    };
    const onCreate = async () => {
        const classesToCreate = filteredFederationClasses.filter((item) => item.federation_class_id && selectedClassIds.includes(String(item.federation_class_id)));
        if (classesToCreate.length === 0) {
            notification.warning({
                message: _T('class.empty.modal.no-selection')
            });
            return;
        }
        setIsSaving(true);
        const results = await Promise.allSettled(classesToCreate.map((item) => Api.create(ClassesSource(competition_id).url, {
            division_id: item.division_id,
            discipline_id: item.discipline_id,
            federation_class_id: item.federation_class_id,
            class_label: item.federation_class_name || '',
            class_name: item.federation_class_code || item.federation_class_legacy_code || ''
        })));
        setIsSaving(false);
        const successCount = results.filter(result => result.status === 'fulfilled').length;
        const failureCount = results.length - successCount;
        if (successCount > 0) {
            notification.success({
                message: _T('class.empty.modal.success', { count: successCount })
            });
        }
        if (failureCount > 0) {
            notification.error({
                message: _T('class.empty.modal.failed', { count: failureCount })
            });
        }
        if (failureCount === 0) {
            setVisible(false);
        }
    };
    const toggleDisciplineSelection = (disciplineClasses) => {
        const disciplineClassIds = disciplineClasses
            .map((item) => item.federation_class_id)
            .filter(Boolean)
            .map((value) => String(value));
        if (disciplineClassIds.length === 0) {
            return;
        }
        setSelectedClassIds((current) => {
            const next = new Set(current.map((id) => String(id)));
            const allSelected = disciplineClassIds.every((id) => next.has(id));
            if (allSelected) {
                disciplineClassIds.forEach((id) => next.delete(id));
            }
            else {
                disciplineClassIds.forEach((id) => next.add(id));
            }
            return Array.from(next);
        });
    };
    return (React.createElement(Modal, { title: _T('class.empty.modal.title'), open: visible, width: 760, onCancel: onClose, mask: { closable: !isSaving }, footer: [
            React.createElement(Button, { key: "cancel", onClick: onClose, disabled: isSaving }, _T('common.cancel.title')),
            React.createElement(Button, { key: "save", type: "primary", onClick: onCreate, loading: isSaving, disabled: disabled || selectedClassIds.length === 0 }, _T('class.empty.modal.create-action'))
        ] },
        React.createElement(Space, { orientation: "vertical", style: { width: '100%' }, size: "middle" },
            React.createElement(Text, { type: "secondary" }, _T('class.empty.modal.description')),
            React.createElement(Divider, { style: { margin: 0 } }),
            React.createElement(Space, { orientation: "vertical", style: { width: '100%', maxHeight: 420, overflowY: 'auto' }, size: "middle" },
                loadingFederationClasses && React.createElement(Spin, null),
                !loadingFederationClasses && groupedClasses.length === 0 && (React.createElement(Empty, { description: _T('class.empty.modal.no-federation-classes') })),
                !loadingFederationClasses && groupedClasses.length > 0 && (React.createElement(Collapse, { style: { width: '100%' }, defaultActiveKey: groupedClasses.map(group => group.divisionId), items: groupedClasses.map(group => {
                        const selectedInDivision = group.classes.filter(item => item.federation_class_id && selectedClassIds.includes(String(item.federation_class_id))).length;
                        return {
                            key: group.divisionId,
                            label: (React.createElement(Space, null,
                                React.createElement(Text, { strong: true }, group.divisionName),
                                React.createElement(Text, { type: "secondary" },
                                    "(",
                                    selectedInDivision,
                                    "/",
                                    group.classes.length,
                                    ")"))),
                            children: (React.createElement(Checkbox.Group, { value: selectedClassIds, onChange: (values) => setSelectedClassIds(values.map(value => String(value))), disabled: disabled || isSaving, style: { width: '100%' } },
                                React.createElement(Space, { orientation: "vertical", style: { width: '100%' } }, group.disciplines.map((disciplineGroup, index) => (React.createElement(Space, { key: disciplineGroup.disciplineId, orientation: "vertical", style: { width: '100%' } },
                                    React.createElement(Button, { type: "link", disabled: disabled || isSaving, style: { padding: 0, height: 'auto', alignSelf: 'flex-start' }, onClick: () => toggleDisciplineSelection(disciplineGroup.classes) },
                                        React.createElement(Space, null,
                                            React.createElement(Text, { type: "secondary" }, disciplineGroup.disciplineName),
                                            React.createElement(Text, { type: "secondary" },
                                                "(",
                                                disciplineGroup.classes.filter(item => item.federation_class_id && selectedClassIds.includes(String(item.federation_class_id))).length,
                                                "/",
                                                disciplineGroup.classes.length,
                                                ")"))),
                                    React.createElement(Space, { orientation: "vertical", style: { width: '100%' } }, disciplineGroup.classes.map((item) => (React.createElement(Checkbox, { key: item.federation_class_id, value: String(item.federation_class_id) }, item.federation_class_name || item.federation_class_code)))),
                                    index < group.disciplines.length - 1 && React.createElement(Divider, { style: { margin: '8px 0' } })))))))
                        };
                    }) }))))));
};
const ClassListItem = (props) => {
    const { event_id, competition_id, classItem, disabled } = props;
    const screens = useBreakpoint();
    const [expanded, setExpanded] = useState(false);
    const [editing, setEditing] = useState(false);
    const { token } = useToken();
    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: classItem.class_id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    const handleClickExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };
    const handleClickEdit = (event) => {
        event.stopPropagation();
        setEditing(true);
    };
    return (React.createElement(List.Item, { ref: setNodeRef, style: { ...style, padding: 0 }, ...attributes },
        React.createElement(List.Item.Meta, { style: { marginBottom: 0 }, description: React.createElement(Row, { justify: 'space-between', onClick: handleClickExpand, style: { padding: 8 } },
                React.createElement(Space, null,
                    React.createElement(Button, { type: "text", onClick: handleClickExpand },
                        React.createElement(Space, null,
                            parseInt(classItem.class_group_id) > 0 &&
                                React.createElement(CaretUpOutlined, null),
                            ClassItem.getClassLabel(classItem),
                            screens.sm &&
                                React.createElement(React.Fragment, null,
                                    parseInt(classItem.round_count) > 0 &&
                                        React.createElement(Badge, { overflowCount: 999, count: classItem.round_count }),
                                    parseInt(classItem.class_count) > 0 &&
                                        React.createElement(Badge, { overflowCount: 999, count: classItem.class_count, color: token.colorWarning })))),
                    !disabled &&
                        React.createElement(EditOutlined, { onClick: handleClickEdit, disabled: disabled })),
                React.createElement(Space, null,
                    !disabled &&
                        React.createElement(MenuOutlined, { ...listeners, style: { cursor: "grab", color: "#999" } }),
                    expanded ? React.createElement(DownOutlined, { onClick: handleClickExpand }) : React.createElement(RightOutlined, { onClick: handleClickExpand }))) }),
        expanded &&
            React.createElement(ClassItemView, { key: classItem.class_id, event_id: event_id, competition_id: classItem.competition_id, classItem: classItem, disabled: disabled }),
        editing &&
            React.createElement(ClassItemEdit, { competition_id: competition_id, classItem: classItem, visible: editing, setVisible: () => setEditing(false) })));
};
